import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=995b0c84&scoped=true&"
import script from "./ToDo.vue?vue&type=script&lang=ts&"
export * from "./ToDo.vue?vue&type=script&lang=ts&"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=995b0c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995b0c84",
  null
  
)

export default component.exports